import React, { useEffect, useState } from 'react';
import { Container, Form, Button, Row, Col, Alert } from 'react-bootstrap';
import queryString from 'query-string';
import { useHistory, useLocation } from 'react-router-dom';
import axiosInterceptor from '../../axiosInterceptor';
import loader from '../../assets/images/loading.gif';
import '../../styles/loader.css';
import '../../styles/email.css';

function AddEmailPage() {
    const history = useHistory();

    const [userName, setUserName] = useState('');
    const [isEmail, setIsEmail] = useState('');
    const [emailValid, setEmailValid] = useState(true);
    const [emailExists, setEmailExists] = useState(false);
    const [emailSubmit, setEmailSubmit] = useState(false);
    const [enterSubmit, setEnterSubmit] = useState(false);

    const emailRegrex =
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    useEffect(() => {
        setUserName(history.location.state.username);
        setIsEmail('');
        setEmailValid(true);
        if (history.location.state.username == '') {
            waitToRead();
        }
    }, []);

    let addEmail = async () => {
        // Email Validation
        if (emailRegrex.test(isEmail)) {
            setEmailValid(true);
        } else {
            setEmailValid(false);
        }
        if (emailRegrex.test(isEmail)) {
            // Check Email exists or not
            const email_check = await axiosInterceptor().post(
                'twitter/checkEmail',
                {
                    email: isEmail
                }
            );
            // No email exists on DB
            if (email_check?.data?.check === 'No Email') {
                addEmailToDB();
                setEnterSubmit(true);
                setEmailExists(false);
            } 
            // Email already exists
            else if (email_check?.data?.check === 'Email already exists') {
                setEmailExists(true);
            }
        }
    };

    let addEmailToDB = async () => {
        // Update user object with email
        const user_check = await axiosInterceptor().post(
            'twitter/updateMoralsUser',
            {
                username: userName,
                email: isEmail
            }
        );

        if (user_check?.data?.check == 'Updated') {
            // Send Verification Email to user
            const verification = await axiosInterceptor().post(
                'twitter/sendVerification',
                {
                    email: isEmail
                }
            );
            // After sending verification email, logout
            if (verification?.data?.check == 'Success') {
                setEmailSubmit(true);
                await logout();
            }
        }
    };

    let redirectToMainPage = async () => {
        //  Logout functionality
        await axiosInterceptor().post('twitter/auth/logout', {
            oauth_token: localStorage.getItem('oauth_token')
        });
        localStorage.removeItem('access_token');
        localStorage.removeItem('oauth_token');
        localStorage.removeItem('portal');
        setEmailSubmit(false);
        setEnterSubmit(false);
        history.push('/');
    };

    let waitToRead = async () => {
        let i = 0;
        const interval = setInterval(async () => {
            await redirectToMainPage();
            i += 1;
            if (i === 1) {
                clearInterval(interval);
            }
        }, 20 * 1000);
    };

    // Logout Function
    let logout = async () => {
        let i = 0;
        const interval = setInterval(async () => {
            await redirectToMainPage();
            i += 1;
            if (i === 1) {
                clearInterval(interval);
            }
        }, 5 * 1000);
    };

    return (
        <Container fluid>
            {userName == '' && (
                <Row
                    className="col-sm-12 col-m-5 col-lg-offset-3"
                    id="verifiedTwitter"
                >
                    <Col>
                        You are ineligible of using twitter functionality. Click{' '}
                        <a
                            onClick={(e) => {
                                e.preventDefault();
                                redirectToMainPage();
                            }}
                            style={{
                                color: 'blue',
                                cursor: 'pointer'
                            }}
                        >
                            here
                        </a>{' '}
                        for redirecting to YourMorals SignIn page.
                    </Col>
                </Row>
            )}
            {userName != '' && (
                <Row>
                    <Col className="col-sm-12 col-m-5 col-lg-offset-3">
                        <Form className="emailForm">
                            <Form.Group
                                className="mb-3c"
                                controlId="formBasicEmail"
                            >
                                <Form.Label className="emailLabel">
                                    Please link your email address
                                </Form.Label>
                                <Form.Control
                                    type="email"
                                    placeholder="Enter email"
                                    onChange={(e) => {
                                        setIsEmail(e.target.value);
                                    }}
                                />
                                {!emailValid && (
                                    <Form.Label className="error">
                                        Enter valid email address
                                    </Form.Label>
                                )}

                                {emailExists && (
                                    <Form.Label className="error">
                                        Email address already exists. Please use
                                        the YourMorals{' '}
                                        <a
                                            onClick={(e) => {
                                                e.preventDefault();
                                                redirectToMainPage();
                                            }}
                                            style={{
                                                color: 'blue',
                                                cursor: 'pointer'
                                            }}
                                        >
                                            sign-in
                                        </a>
                                        , and then go to My Profile to link your
                                        Twitter account to your YourMorals
                                        account.
                                    </Form.Label>
                                )}
                                <Form.Text className="text-muted emailTextMuted">
                                    We'll never share your email with anyone
                                    else. The next step is to verify your email
                                    address for successful registration.
                                </Form.Text>
                            </Form.Group>

                            <a
                                className="btn btn-primary btn-block emailSubmit"
                                style={{
                                    display: enterSubmit ? 'none' : 'block'
                                }}
                                onClick={(e) => {
                                    addEmail();
                                    e.preventDefault();
                                }}
                                role="button"
                            >
                                Submit
                            </a>
                        </Form>
                    </Col>
                </Row>
            )}{' '}
            {emailSubmit && (
                <>
                    <br />
                    <Alert variant="success" className="text-center">
                        Email Sent. Please check your email to verify email
                        address.
                    </Alert>
                </>
            )}
        </Container>
    );
}

export default AddEmailPage;
